import { CardBlockCardFragment } from '@lib/umbraco/generated/types.generated'
import React, { ComponentType, FC } from 'react'
import CardBlockCardDefault from './variants/CardBlockCardDefault'

interface Props extends CardBlockCardFragment {
  variant: string
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type CardBlockCardProps = Props & NativeAttrs

const componentMapping: Record<string, ComponentType<any>> = {
  Default: CardBlockCardDefault,
}

const CardBlockCard: FC<CardBlockCardProps> = ({
  className,
  variant,
  ...props
}) => {
  if (!variant) {
    return null
  }
  const Component = componentMapping[variant]
  if (!Component) {
    return <div data-type={variant} className={className as string} />
  }
  return (
    <Component data-type={variant} {...props} className={className as string} />
  )
}

CardBlockCard.displayName = 'CardBlockCard'
export default CardBlockCard
